import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { indexedDBService } from '../../services/indexdb-service';
import { LoadingDialog } from '../../components/HelperComponents/LoadingDialog';

export const LogoutLoader: React.FunctionComponent = () => {

    const { logout } = useAuth0();
    const navigate = useNavigate();
    const landingNav = async () => {
        navigate("/landing");
    };

    const doLogout = async () => {
        logout({ logoutParams: { returnTo: window.location.origin + '/landing' } });
        removeAllCookies();
        localStorage.clear();
        indexedDBService.clearItems();
        emptyCache();
    };

    function removeAllCookies() {
        // Get all cookies using document.cookie and split into individual cookies
        var cookies = document.cookie.split(";");

        // Iterate through all cookies and remove them
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }

    function emptyCache() {
        if ('caches' in window) {
            caches.keys().then((names) => {
                names.forEach((name) => {
                    caches.delete(name);
                });
            });
        }
    }

    useEffect(() => {
        doLogout();
        window.addEventListener('popstate', landingNav);
    }, []);

    const divStyle = {
        display: 'grid',
        placeItems: 'center',
    };

    return (
        <LoadingDialog />
    )
}